import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const englishRemoteUICopy = {
    connectionUnavailable: 'Connection unavailable',
    agentFailed: 'Agent failed',
    executingCommand: 'Executing command',
    agentActivity: 'Agent activity',
    turnElapsedTime: 'Turn elapsed time',
    interruptOperation: 'Interrupt the current native operation',
    interruptUnavailable: 'Interrupt is unavailable for this Provider.',
    subagents: 'Subagents',
    subagentOpenFailed: 'This subagent could not be opened.',
    opening: 'Opening…',
    savedHistory: 'Saved history',
    documentationLoadFailed: 'Unable to load skill documentation.',
    closeSkillDetails: 'Close skill details',
    loadingDocumentation: 'Loading documentation…',
    descriptionOnly: 'This Provider exposes a description without full documentation.',
    documentationUnavailable: 'Documentation is not available to preview.',
    retryDocumentation: 'Retry documentation',
    openAgentFirst: 'Open or attach to an Agent first.',
    nativeCommandFailed: 'Native command failed.',
    cancellationRequested: 'Cancellation requested.',
    interruptFailed: 'Interrupt failed.',
    unknownNativeCommand: 'Unknown or unavailable native command. Open / to refresh the command list.',
    messageSent: 'Message sent.',
    messageSteered: 'Input accepted for the current turn.',
    steerCurrentTurn: 'Steer current turn',
    steer: 'Steer',
    steering: 'Steering…',
    messageQueued: 'Message queued by Provider.',
    agentCommandFailed: 'Agent command failed.',
    liveProviderControls: 'Live provider controls',
    loadingNativeCommands: 'Loading native commands…',
    retry: 'Retry',
    nativeCommandsUnavailable: 'This Provider does not expose native commands.',
    noMatchingCommands: 'No matching native commands.',
    nativeCommands: 'Native commands',
    console: 'Console',
    selectedSkill: 'Selected skill',
    skillWaitForTurn: 'This Provider can invoke skills when the current turn finishes.',
    message: 'Message',
    messagePlaceholder: 'Message the Agent…',
    openChatCommands: 'Open chat commands',
    queueing: 'Queueing…',
    queueNextTurn: 'Queue for next turn',
    queueNativeHint: 'Let the native Provider handle this after the current turn',
    queue: 'Queue',
    interrupting: 'Interrupting…',
    interruptRequested: 'Interrupt requested',
    interrupt: 'Interrupt',
    sending: 'Sending…',
    sendMessage: 'Send message',
    sendToActiveTurn: 'Send input to the active native turn',
    startNativeTurn: 'Start a new native turn',
    planningChangeFailed: 'Planning mode could not be changed.',
    sessionPlanningMode: 'Session planning mode',
    planning: 'Planning',
    normalChat: 'Normal chat',
    planningMode: 'Planning mode',
    on: 'On',
    off: 'Off',
    planningUnsupported: 'Planning is not supported by this session.',
    planningReadOnly: 'Planning mode is read-only for this session.',
    waitingPlanningState: 'Waiting for Provider planning state.',
    waitingProviderConfirmation: 'Waiting for Provider confirmation.',
    planningChangeUnavailable: 'Planning can change only while connected and idle, with no pending interactions.',
    planningConfirmed: 'Provider confirmed. Changes apply to the next message.',
    settingChangeFailed: 'Session setting could not be changed.',
    unavailable: 'Unavailable',
    sessionControls: 'Session controls',
    model: 'Model',
    permissions: 'Permissions',
    sessionStatusLabel: 'Status',
    sessionStatusAndPlanning: 'Session status and planning',
    sessionStatus: 'Session status',
    modelSettings: 'Model settings',
    permissionSettings: 'Permission settings',
    closeSessionControls: 'Close session controls',
    backToSessionControls: 'Back to session controls',
    close: 'Close',
    provider: 'Provider',
    session: 'Session',
    connection: 'Connection',
    connected: 'Connected',
    runtime: 'Runtime',
    directory: 'Directory',
    settingChangesDefault: 'Also changes the default for future sessions.',
    settingsDisconnected: 'Disconnected. Values are last known; reconnect to change settings.',
    settingsChangeUnavailable: 'Settings can change only while idle with no pending interactions.',
    settingsApplyNextTurns: 'Changes apply to subsequent turns.',
    settingsUnsupported: 'This Provider does not expose these session settings.',
    openResource: 'Open resource',
    downloadResource: 'Download resource',
    loadingResource: 'Loading resource…',
    loadResource: 'Load resource',
    resourceRequestFailed: 'Resource request failed.',
    referencedResources: 'Referenced resources',
    resources: 'Resources',
    informationRequest: 'INFORMATION REQUEST',
    submit: 'Submit',
    decline: 'Decline',
    cancel: 'Cancel',
    required: 'Required',
    choose: 'Choose…',
    yes: 'Yes',
    no: 'No',
    answerHiddenInHistory: 'This answer is hidden in conversation history.',
    permissionRequest: 'PERMISSION REQUEST',
    reviewRequestedAccess: 'Review requested access',
    continueInBrowser: 'CONTINUE IN BROWSER',
    externalLinkUnavailable: 'The requested link cannot be opened.',
    returnAfterAction: 'Return here after completing the action.',
    externalActionCompleted: 'I have completed this',
    form: 'FORM',
    submitted: 'Submitted',
    declined: 'Declined',
    notProvided: 'Not provided',
    permissionReceipt: 'PERMISSIONS',
    externalAction: 'EXTERNAL ACTION',
    toolResult: 'Tool result',
    result: 'Result',
    noOutput: 'No output.',
    showFullResult: 'Show full result',
    showDetails: 'Show details',
    rawResult: 'Raw result',
    noResults: 'No results.',
    fileChanges: 'File changes',
    fileChangesPreview: 'File changes preview',
    noFileChanges: 'No file changes reported.',
    noDiffContent: 'No diff content provided.',
    previousFile: 'from',
    fileChangeKind: kind => ({ added: 'Added', modified: 'Modified', deleted: 'Deleted', renamed: 'Renamed', unknown: 'File change' })[kind],
    diffStats: (added, deleted) => `${added} added lines, ${deleted} deleted lines`,
    fileDiff: path => `Diff for ${path}`,
    fileDiffPreview: path => `Diff preview for ${path}`,
    moreFiles: count => `${count} more files`,
    moreOutputBlocks: count => `${count} more output blocks`,
    output: 'Output',
    resultTruncated: 'Result truncated to fit the timeline.',
    nativeCommandsLoadFailed: 'Unable to load native commands.',
    detailRendererUnavailable: 'Detail renderer unavailable',
    agentTimeline: 'Agent timeline',
    remoteSession: 'REMOTE SESSION',
    connecting: 'Connecting',
    noTimelineActivity: 'No timeline activity.',
    sessionSubagents: 'Session subagents',
    pendingInteractions: 'Pending interactions',
    earlierActivityLoadFailed: 'Earlier activity could not be loaded.',
    loadingEarlierActivity: 'Loading earlier activity…',
    loadEarlierActivity: 'Load earlier activity',
    runtimeStatus: (status) => ({ starting: 'Starting', idle: 'Ready', running: 'Working', waiting: 'Waiting for response', failed: 'Failed', closed: 'Closed' })[status],
    resourceStatus: (status) => ({ pending: 'Pending', available: 'Available', failed: 'Failed', unavailable: 'Unavailable' })[status],
    commandKind: (kind) => ({ skill: 'Skill', command: 'Command', prompt: 'Prompt' })[kind],
    commandDetails: (kind) => kind === 'skill' ? 'Skill details' : 'Command details',
    viewSkill: (name) => `View skill ${name}`,
    removeSkill: (name) => `Remove skill ${name}`,
    composerKeyboardHint: (active) => `${active ? 'Enter to send now' : 'Enter to send'} · Shift+Enter for a new line · / for commands`,
    modelTitle: (value) => `Model: ${value}`,
    permissionsTitle: (value) => `Permissions: ${value}`,
    lastKnown: (value) => `${value} (last known)`,
    byteCount: (count) => `${count} bytes`,
    formValidation: (label, reason) => `${label} ${{ required: 'requires a value.', range: 'is outside the allowed range.', selections: 'has an invalid number of selections.', length: 'has an invalid length.' }[reason]}`,
    allowPermission: (scope) => scope === 'turn' ? 'Allow for turn' : 'Allow for session',
    allowedPermission: (scope) => scope === 'turn' ? 'Allowed · turn' : 'Allowed · session',
    permissionAccess: (access) => ({ read: 'read', write: 'write', deny: 'deny', connect: 'connect' })[access],
    permissionResource: (resource) => resource === 'filesystem' ? 'filesystem' : 'network',
    openExternalHost: (host) => `Open ${host}`,
    exitCode: (code) => `Exit code ${code}`,
    durationMs: (duration) => `${duration} ms`,
    elapsedTime: (seconds) => {
        if (seconds < 60)
            return `${seconds}s`;
        const minutes = Math.floor(seconds / 60);
        const remainder = String(seconds % 60).padStart(2, '0');
        if (minutes < 60)
            return `${minutes}m ${remainder}s`;
        return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m ${remainder}s`;
    },
    interactionUnavailable: 'Interaction unavailable',
    invalidInteraction: 'Invalid interaction request',
    missingApprovalScope: 'Allow was offered with no approval scope.',
    unsupportedInteraction: 'Unsupported interaction',
    unknownInteraction: 'unknown',
    inputRequired: 'INPUT REQUIRED',
    agentQuestions: 'Agent questions',
    questions: 'Questions',
    customResponse: 'Custom response',
    previous: 'Previous',
    next: 'Next',
    submitting: 'Submitting…',
    submitResponse: 'Submit response',
    dismiss: 'Dismiss',
    toolAuthorization: 'TOOL AUTHORIZATION',
    deny: 'Deny',
    planReview: 'PLAN REVIEW',
    reviewProposedPlan: 'Review proposed plan',
    revisionFeedback: 'Revision feedback',
    planFeedbackPlaceholder: 'What should the Agent change?',
    planFeedbackHint: 'Add feedback to request a revised plan.',
    toolApproval: 'TOOL APPROVAL',
    denied: 'Denied',
    mismatchedInteraction: 'The recorded interaction response does not match its request.',
    dismissed: 'Dismissed',
    answered: 'Answered',
    partiallyAnswered: 'Partially answered',
    noAnswers: 'No answers',
    hideQuestions: 'Hide questions',
    showQuestions: 'Show questions',
    noAnswerProvided: 'No answer provided',
    reasoningTrace: 'Reasoning trace',
    taskBoard: 'TASK BOARD',
    executionPlan: 'Execution plan',
    contextCompaction: 'Context compaction',
    agentError: 'Agent error',
    hiddenAnswer: 'Hidden answer',
    runtimeNotice: 'Runtime notice',
    markdownTable: 'Markdown table',
    footnotes: 'Footnotes',
    userMessage: 'User message',
    assistantMessage: 'Assistant message',
    you: 'You',
    assistant: 'Assistant',
    interactionUnavailableReason: (kind) => `The host cannot respond to this ${{ question: 'question', plan_approval: 'plan approval', tool_approval: 'tool approval', form: 'form', permission_approval: 'permission approval', external_action: 'external action' }[kind]} request.`,
    interactionResponseError: (error) => error instanceof Error && error.message ? error.message : 'Interaction response failed.',
    answerRequired: (header) => `${header} requires an answer.`,
    questionTab: (index, header, answered) => `${index}. ${header}${answered ? ', answered' : ''}`,
    questionCount: (count) => `${count} ${count === 1 ? 'question' : 'questions'}`,
    answeredCount: (answered, total) => `${answered} of ${total} answered`,
    allow: (scope) => scope === 'once' ? 'Allow once' : 'Allow for session',
    allowed: (scope) => scope === 'once' ? 'Allowed · once' : 'Allowed · session',
    planAction: (action, hasFeedback) => action === 'approve' ? 'Approve' : action === 'approve_and_resume' ? 'Approve and execute' : hasFeedback ? 'Request changes' : 'Request revision',
    planResult: (action) => action === 'reject' ? 'Rejected' : action === 'approve_and_resume' ? 'Approved and resumed' : 'Approved',
    status: (status) => ({ pending: 'Pending', in_progress: 'In progress', running: 'Running', completed: 'Completed', failed: 'Failed', canceled: 'Canceled' })[status],
    toolDetail: (type) => ({ read: 'read', edit: 'edit', write: 'write', search: 'query', fetch: 'URL' })[type],
    compactionTrigger: (trigger) => `Trigger: ${trigger}`,
    footnoteBack: (referenceIndex, rereferenceIndex) => `Back to reference ${referenceIndex + 1}${rereferenceIndex > 1 ? `-${rereferenceIndex}` : ''}`,
};
export function resolveRemoteUIMessage(copy, message) {
    return 'text' in message ? message.text : copy[message.key];
}
const RemoteUICopyContext = createContext(englishRemoteUICopy);
export const RemoteUICopyProvider = ({ copy, children }) => (_jsx(RemoteUICopyContext.Provider, { value: copy, children: children }));
export const useRemoteUICopy = () => useContext(RemoteUICopyContext);
//# sourceMappingURL=copy.js.map